import { SearchIcon } from "@primer/octicons-react";
import { useEffect, useState } from "react";
import { useDebounce } from "use-debounce";

import { ActionList, AnchoredOverlay, Box } from "@primer/react";
import TextInput from "../ui/text-input";
import { IMyTextInputProps } from "../ui/text-input/TextInput";
import { IHocSinhSearchRespone } from "../../models/response/category/IHocSinhSearchRespone";
import { IHocSinhViewModel } from "../../models/response/category/IHocSinhViewModel";
import { hocSinhApi } from "../../api/hocSinhApi";
import Text from "../ui/text";
import { useSelector } from "react-redux";
import { RootState } from "../../state/reducers";

interface IHocSinhSearchProps extends IMyTextInputProps {
    isOpenSearchModal?: boolean
    anchorComponent?: React.ReactNode,
    onHocSinhSelected: (hocSinh: IHocSinhViewModel) => void
}
const HocSinhSearch = (props: IHocSinhSearchProps) => {
    const [searchKey, setSearchKey] = useState<string>("");
    const searchKeyDelayed = useDebounce(searchKey, 300)[0];
    const [searchData, setSearchData] = useState<IHocSinhSearchRespone>();
    const [isOpenOverlay, setIsOpenOverlay] = useState(props.isOpenSearchModal ?? false);
    const { nam_hoc, dm_coso_id } = useSelector((x: RootState) => x.common);

    useEffect(() => {
        if (searchKeyDelayed) {
            handleSearchAsync();
        }
    }, [searchKeyDelayed])
    const handleSearchAsync = async () => {
        const res = await hocSinhApi.SearchByKey({
            page_index: 0,
            page_size: 10,
            search_key: searchKeyDelayed,
            nam_hoc,
            dm_coso_id
        })
        if (res.is_success) {
            setSearchData(res.data);
        }
    }


    return (
        <Box>
            <AnchoredOverlay
                open={isOpenOverlay}
                onClose={() => {
                    setIsOpenOverlay(false)
                }}
                overlayProps={{
                    role: 'dialog',
                    'aria-modal': true,
                    'aria-label': 'User Card Overlay',

                }}
                focusZoneSettings={{
                    disabled: true
                }}
                renderAnchor={(anchorProps) => {
                    return (
                        <Box
                            {...anchorProps}
                            onClick={() => {
                                setIsOpenOverlay(true)
                            }}
                        >
                            {props.anchorComponent ? props.anchorComponent :
                                <TextInput trailingVisual={SearchIcon}
                                    placeholder='Tìm kiếm học sinh theo mã, họ tên'
                                    sx={{
                                        borderRadius: '10px',
                                        ...props.sx
                                    }}
                                />
                            }
                        </Box>

                    );
                }}

            >
                <Box sx={{
                    height: 600,
                    overflowY: "auto",
                    width: "400px",
                }}>
                    <Box sx={{
                        width: "100%",
                        p: 3,
                        display: 'flex',
                        flexDirection: "column"
                    }}>
                        <Box>
                            <TextInput trailingVisual={SearchIcon}
                                placeholder='Tìm kiếm học sinh theo mã, họ tên'
                                sx={{
                                    borderRadius: '100px',
                                }}
                                onChange={(e) => {
                                    setSearchKey(e.target.value)
                                    if (e.target.value) {
                                        setIsOpenOverlay(true)
                                    } else {
                                        // setIsOpenOverlay(false)
                                    }
                                }}
                                block
                            />
                        </Box>

                        <Box sx={{ pt: 2 }}>
                            {searchData &&
                                <Box>
                                    <Box sx={{ color: "fg.muted", display: "flex", p: 2 }}>
                                        <Box sx={{
                                            fontWeight: 600
                                        }}>
                                            Tổng số:    {searchData.total_count}
                                        </Box>
                                    </Box>
                                    <ActionList variant="full" showDividers>
                                        {searchData.data && searchData.data.map((sv: IHocSinhViewModel) => {
                                            return (
                                                <ActionList.Item key={sv.id} onSelect={() => {
                                                    props.onHocSinhSelected(sv)
                                                    setIsOpenOverlay(false)
                                                }}>
                                                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                                                        <Box sx={{ display: "flex", fontSize: "14px" }}>
                                                            <Box sx={{ flex: 1 }}>
                                                                <Text text={sv.ho_ten} sx={{ fontWeight: 600 }} />
                                                            </Box>
                                                            <Box>
                                                                <Text text={sv.ma_hs} sx={{ fontWeight: 600, color: "fg.muted" }} />
                                                            </Box>

                                                        </Box>
                                                    </Box>
                                                    <Box sx={{ color: "fg.muted" }}>
                                                        Lớp:   {sv.ten_lop}
                                                    </Box>
                                                    {/* <Box sx={{ color: "fg.muted" }}>
                                                        Hệ {sv.ten_he}
                                                    </Box>
                                                    <Box sx={{ color: "fg.muted" }}>
                                                        Trường {sv.ten_truong}
                                                    </Box> */}
                                                </ActionList.Item>
                                            );
                                        })}
                                    </ActionList>
                                </Box>

                            }
                        </Box>
                    </Box>
                </Box>
            </AnchoredOverlay>
        </Box>

    );
};

export default HocSinhSearch;